import styled from 'styled-components'

export const StyledAbbr = styled.abbr`
  cursor: help;
`;